var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saturn-force"},[_c('span',{staticClass:"saturn-force-text"},[_vm._v("One more thing…")])])
}]

export { render, staticRenderFns }